import React from "react";
import { useNavigate } from "react-router-dom";

const PaidFeaturePopup = ({ isOpen, onClose }) => {
  const navigate = useNavigate();
  if (!isOpen) return null;

  return (
    <div
      style={{
        position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)",
        display: "flex", alignItems: "center", justifyContent: "center",
        zIndex: 9999,
      }}
      onClick={onClose}
    >
      <div
        style={{
          background: "#fff", borderRadius: "16px", padding: "32px 28px",
          maxWidth: "400px", width: "90%", textAlign: "center",
          boxShadow: "0 20px 60px rgba(0,0,0,0.25)",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div style={{ fontSize: "48px", marginBottom: "12px" }}></div>
        <h3 style={{ fontSize: "18px", fontWeight: "700", color: "#1a1a1a", marginBottom: "10px" }}>
          Paid Feature
        </h3>
        <p style={{ fontSize: "15px", color: "#555", lineHeight: "1.6", marginBottom: "20px" }}>
          This feature is only available in School Plans.
        </p>
        <div style={{ display: "flex", gap: "10px", justifyContent: "center" }}>
          <button
            onClick={() => { onClose(); navigate("/pricing"); }}
            style={{
              background: "#0066CC", color: "#fff", padding: "10px 22px",
              borderRadius: "50px", fontWeight: "700", fontSize: "14px",
              border: "none", cursor: "pointer",
            }}
          >
            Upgrade Now
          </button>
          <button
            onClick={onClose}
            style={{
              background: "#f1f5f9", color: "#333", padding: "10px 22px",
              borderRadius: "50px", fontWeight: "600", fontSize: "14px",
              border: "none", cursor: "pointer",
            }}
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default PaidFeaturePopup;
